'use client'

import React from 'react'
import { rt } from '@/shared/components/interactive/RichText'
import ScrollRevealText from './ScrollRevealText'
import { motion } from 'framer-motion'

type Props = {}

export default function ScrollSectionVic({}: Props) {
  const textClass =
    'text-center font-display text-3xl  xl:text-5xl font-light leading-loose text-gray-700'

  return (
    <div className="relative mx-auto flex max-w-5xl flex-col items-center gap-y-24 xl:gap-y-32">
      <ScrollRevealText
        blocks={[
          rt({
            content: {
              value: 'Say each doctor visit takes just',
            },
          }),
          rt({
            content: {
              value: '60 minutes',
              box: 'bg-blue-600',
            },
          }),
          rt({
            content: {
              value: 'total, Victoria residents collectively spend over',
            },
          }),
          rt({
            content: {
              value: '2,900,000,000 minutes',
              className: 'text-rose-500 font-medium',
            },
          }),
          rt({
            content: {
              value: 'at clinics yearly.',
            },
          }),
        ]}
        className={textClass}
      />
      <motion.div
        className="overflow-hidden"
        initial="start"
        whileInView="end"
        viewport={{ once: true, amount: 'all' }}
      >
        <motion.p
          className={textClass}
          variants={{
            start: {
              y: 100,
            },
            end: {
              y: 0,
            },
          }}
          transition={{ ease: 'easeOut', duration: 0.5 }}
        >
          That{"'"}s{' '}
          <span className="relative inline-flex overflow-hidden font-bold">
            <motion.span
              className="absolute bottom-3 left-0 block h-2 w-full bg-blue-400 lg:bottom-1 lg:h-4"
              variants={{
                start: { width: 0 },
                end: { width: '100%' },
              }}
              transition={{ ease: 'easeOut', duration: 0.5, delay: 0.3 }}
            ></motion.span>
            <span className="relative inline-block">5,517 years</span>
          </span>
        </motion.p>
      </motion.div>
      <ScrollRevealText
        blocks={[
          rt({
            content: {
              value: ' In that same time, you could have',
            },
          }),
        ]}
        className={textClass}
      />
    </div>
  )
}
